import moment from 'moment';

import {
  SET_HOME_DATE_RANGE,
  SET_HOME_DATE_RANGE_PRESET,
  SET_HOME_DATE_RANGE_ALL_TIME,
  FETCH_CLIENT,
  SET_CLIENT,
  FETCH_HOME_SUMMARY,
  SET_HOME_SUMMARY,
  FETCH_POI_COUNT,
  SET_POI_COUNT,
  FETCH_HOME_ORGANISATIONS,
  SET_HOME_ORGANISATIONS,
  FETCH_PROSPECTS_TO_WATCH_DATA,
  SET_PROSPECTS_TO_WATCH_DATA,
  FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
  SET_WHERE_YOUR_CUSTOMERS_HAVE_BEEN,
  FETCH_BIGGEST_MOVERS,
  SET_BIGGEST_MOVERS,
  LOG_OUT,
} from '../constants';

const initialState = {
  sinceDate: moment().subtract(30, 'days').startOf('day').format(),
  untilDate: moment().subtract(1, 'days').endOf('day').format(),
  prevSince: moment()
    .subtract(60, 'days')
    .subtract(30, 'days')
    .startOf('day')
    .format(),
  prevUntil: moment()
    .subtract(31, 'days')
    .subtract(1, 'days')
    .endOf('day')
    .format(),
  prevSinceDate: moment().subtract(60, 'days').startOf('day').format(),
  prevUntilDate: moment().subtract(31, 'days').endOf('day').format(),
  dateRangePreset: 'last30Days',
  allTimeDateRange: false,
  clientLoaded: false,
  clientData: {},
  homeSummaryLoaded: false,
  homeSummaryData: {},
  poiCountLoaded: false,
  poiCountData: {},
  organisationsAllTimeData: [],
  homeOrganisationsLoaded: false,
  homeOrganisationsData: [],
  prospectsToWatchLoaded: false,
  prospectsToWatchData: [],
  whereYourCustomersHaveBeenLoaded: false,
  whereYourCustomersHaveBeenData: [],
  biggestMoversLoaded: false,
  biggestMoversData: {},
};

// Filtering wild data above 400% Change for client demo
/* eslint-disable */
const filterAndOrderBiggestMovers = (array) => {
  if (array !== null && array !== undefined) {
    return array
      .filter((item) => item.percentageChange < 400)
      .sort((a, b) =>
        b.percentageChange > a.percentageChange
          ? 1
          : a.percentageChange > b.percentageChange
          ? -1
          : 0
      );
  } else {
    return [];
  }
};

/* eslint-enable */

const home = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case SET_HOME_DATE_RANGE:
      return {
        ...state,
        sinceDate: action.sinceDate,
        untilDate: action.untilDate,
        prevSinceDate: action.prevSinceDate,
        prevUntilDate: action.prevUntilDate,
        allTimeDateRange: false,
      };
    case SET_HOME_DATE_RANGE_ALL_TIME:
      return {
        ...state,
        allTimeDateRange: true,
        sinceDate: action.sinceDate,
        untilDate: action.untilDate,
      };
    case SET_HOME_DATE_RANGE_PRESET:
      return {
        ...state,
        dateRangePreset: action.dateRangePreset,
      };
    case FETCH_CLIENT:
      return {
        ...state,
        clientLoaded: false,
      };
    case SET_CLIENT:
      return {
        ...state,
        clientLoaded: true,
        clientData: action.data,
      };
    case FETCH_HOME_SUMMARY:
      return {
        ...state,
        homeSummaryLoaded: false,
      };
    case SET_HOME_SUMMARY:
      return {
        ...state,
        homeSummaryLoaded: true,
        homeSummaryData: action.data,
      };
    case FETCH_POI_COUNT:
      return {
        ...state,
        poiCountLoaded: false,
      };
    case SET_POI_COUNT:
      return {
        ...state,
        poiCountLoaded: true,
        poiCountData: action.data,
      };
    case FETCH_HOME_ORGANISATIONS:
      return {
        ...state,
        homeOrganisationsLoaded: false,
      };
    case SET_HOME_ORGANISATIONS:
      return {
        ...state,
        homeOrganisationsLoaded: true,
        homeOrganisationsData: action.data,
      };
    case FETCH_PROSPECTS_TO_WATCH_DATA:
      return {
        ...state,
        prospectsToWatchLoaded: false,
      };
    case SET_PROSPECTS_TO_WATCH_DATA:
      return {
        ...state,
        prospectsToWatchLoaded: true,
        prospectsToWatchData: action.data,
      };
    case FETCH_WHERE_YOUR_CUSTOMERS_HAVE_BEEN:
      return {
        ...state,
        whereYourCustomersHaveBeenLoaded: false,
      };
    case SET_WHERE_YOUR_CUSTOMERS_HAVE_BEEN:
      return {
        ...state,
        whereYourCustomersHaveBeenLoaded: true,
        whereYourCustomersHaveBeenData: action.data,
      };
    case FETCH_BIGGEST_MOVERS:
      return {
        ...state,
        biggestMoversLoaded: false,
      };
    case SET_BIGGEST_MOVERS:
      return {
        ...state,
        biggestMoversLoaded: true,
        biggestMoversData: {
          subcategories: {
            top: filterAndOrderBiggestMovers(action.data.subcategories).slice(
              0,
              3
            ),
            bottom: filterAndOrderBiggestMovers(
              action.data.subcategories
            ).slice(-3),
          },
          organisations: {
            top: filterAndOrderBiggestMovers(action.data.organisations).slice(
              0,
              5
            ),
            bottom: filterAndOrderBiggestMovers(
              action.data.organisations
            ).slice(-5),
          },
        },
      };
    default:
      return state;
  }
};

export default home;
